import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const AffectationsUnassignDialog = ({ isOpen, setIsOpen, selectedEmployeesCount, handleUnassignCalendar }) => {
  const { t } = useTranslation();

  return (
  <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t('holidayAssignments.unassign.title')}</AlertDialogTitle>
        <AlertDialogDescription>
          {t('holidayAssignments.unassign.desc', { count: selectedEmployeesCount })}
          <div className="mt-2 p-2 bg-orange-950/20 border border-orange-900/40 rounded">
            <AlertCircle className="inline h-4 w-4 text-orange-400 mr-1" />
            <span className="text-muted-foreground text-sm">
              {t('holidayAssignments.unassign.warning')}
            </span>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
        <AlertDialogAction onClick={handleUnassignCalendar} className="bg-red-600 hover:bg-red-700">
          {t('holidayAssignments.unassign.submit')}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default AffectationsUnassignDialog;
